const testTypeValue = (_type, _value) =>
{

  const numberPattern = /^-?\d+(\.\d+)?$/;
  const integerPattern = /^(0|[1-9]\d*)$/;

  switch (_type)
  {
    case "int":
      return integerPattern.test(_value);
    case "number":
      return numberPattern.test(_value);
    case "text":
      return true;
    default:
      return false;
  }

};

export const variableValidator = (_variable, _initScript, _step) =>
{

  let listError = [];

  //Validation in the initScript
  _initScript.script.forEach(s =>
  {

    //Check Actions
    s.action.forEach(a =>
    {

      //Does it use the current variable
      if (a.variable == _variable._id)
      {
        //Is the type of variable compatible with the value
        if (!testTypeValue(_variable.variableTypeCode, a.value)){

          listError.push({
            code: "InitScript Action Value Error",
            parameter: {
              ScriptName: s.name,
              VariableValue: a.value,
              VariableType: _variable.variableTypeLabel
            }
          });

        }

      }



    });

    //Check step
    s.condition.forEach(c =>
    {

      //Does it use the current variable
      if (c.variable == _variable._id)
      {

        //Is the type of variable compatible with the value
        if (!testTypeValue(_variable.variableTypeCode, c.value))
        {

          listError.push({
            code: "InitScript Condition Value Error",
            parameter: {
              ScriptName: s.name,
              VariableValue: c.value,
              VariableType: _variable.variableTypeLabel
            }
          });

        }

      }



    });


  });

  //Check each condition of each steps.
  _step.forEach(s => {


    s.condition.forEach(c => {


      c.data.forEach(d => {

        d.forEach(g => {

          let isFound = false;

          ["valueLeft", "valueRight"].forEach(v => {

            //If its a globalVariable, and its the current variable, and has not been found yet for this condition.
            if (g[v].type == "globalVariable" && g[v].variable == _variable._id && !isFound){
              
              isFound = true;

              let valueCompare = (v == "valueLeft") ? "valueRight" : "valueLeft"; 

              if (g[valueCompare].type == "literal"){

                if (!testTypeValue(_variable.variableTypeCode, g[valueCompare].data))
                {

                  //Find Step Target title
                  let StepTarget = _step.find(st => st._id == c.processStep)?.title || "?";

                  listError.push({
                    code: "Step Condition Type Literal Error",
                    parameter: {
                      StepSource: s.title,
                      StepTarget,
                      VariableValue: g[valueCompare].data,
                      VariableType: _variable.variableTypeLabel
                    }
                  });

                }

              }

            } else if (g[v].type == "formula"){

              console.log(g[v]);

            }


              // switch (g[valueCompare].type) {
              //   case "literal":
              //     if (!testTypeValue(_variable.variableTypeCode, g[valueCompare].data)){

              //       //Find Step Target title
              //       let StepTarget = _step.find(st => st._id == c.processStep)?.title || "?";

              //       listError.push({
              //         code: "Step Condition Type Literal Error",
              //         parameter: {
              //           StepSource: s.title,
              //           StepTarget,
              //           VariableValue: g[valueCompare].data,
              //           VariableType: _variable.variableTypeLabel
              //         }
              //       });

              //     }
              //     break;
              //   case "global":

              //     console.log(g[valueCompare])

              //   default:
              //     break;
              // }

              // console.log(g);



          });

        });

      });

    });

  });

  

  return listError;


}